<script>
  export let tabId = "unset";

  import { getContext } from 'svelte';

  let activeTab = "";
  getContext('TabPanelStack').subscribe(value => activeTab = value);

</script>
<div style="display: {tabId === activeTab ? 'block':'none'}"> 
  <slot ></slot>
</div>
